import BaseModel from "./base/baseModel";

export default class CategoriaControleReclamacaoModel extends BaseModel {
    id: number;
    descricao: string = null;
}
